import {format} from "date-fns";
import React, {useEffect, useState} from "react";
import DataTable from "react-data-table-component";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import ApiConnect from "../../../Utils/ApiConnect";
import DeletePop from "../../Components/DeletePop";
import FileViewer from "../../Components/FileViewer";
import QuickView from "../../Components/QuickView";

export default function DayBook() {
  const [startDate, SetstartDate] = useState(new Date());
  const [tableData, SettableData] = useState([]);
  const [totalData, SettotalData] = useState([]);
  const [loading, Setloading] = useState(true);
  const [showQucik, SetshowQuick] = useState(false);
  const [selectedId, SetselectedId] = useState(false);
  const [selectedType, SetselectedType] = useState(false);
  const [triggerModal, SettriggerModal] = useState(false);
  const [viewerTrigger, SetviewerTrigger] = useState(false);
  const [selectedFile, SetselectedFile] = useState(false);
  const [filterText, setFilterText] = useState("");
  const fetchDayBook = () => {
    ApiConnect.get(
      `/Module/Accounts/Report/DayBook?day=${format(startDate, "yyyy-MM-dd")}`
    )
      .then((response) => {
        SettableData(response.data.tableData);
        SettotalData(response.data.totalData);
        Setloading(false);
      })
      .catch((err) => console.log(err));
  };
  useEffect(() => {
    fetchDayBook();
  }, [startDate]);
  const columns = [
    {
      name: "Date",
      selector: row => row.date,
      sortable: true,
      cell: (row) => {
        return (
          <React.Fragment>
            {row.date}
            <br />
            <small>{row.miti}</small>
          </React.Fragment>
        );
      },
    },
    {
      name: "Voucher No",
      selector: row => row.id,
      sortable: true,
      cell: (row) => {
        return (
          <a
            onClick={() => {
              SetselectedId(row.id);
              SetselectedType(row.type);
              SetshowQuick(true);
            }}
            href="#_"
          >
            {row.id}
          </a>
        );
      },
    },
    {
      name: "Description",
      selector: row => row.description,
      sortable: true,
      cell: (row) => {
        return (
          <React.Fragment>
            {row.description}
            <div className="avatar-list avatar-list-overlap">
              {row.attachment
                ? row.attachment.map((att, i) => (
                    <a
                      className="avatar"
                      onClick={() => {
                        SetselectedFile(att);
                        SetviewerTrigger(true);
                      }}
                      key={i}
                      href="#_"
                    >
                      <img src={att} alt={`${row.id}${i}`} />
                    </a>
                  ))
                : ""}
            </div>
          </React.Fragment>
        );
      },
    },
    {
      name: "Payment",
      selector: row => row.payment,
      sortable: true,
    },
    {
      name: "Debit",
      selector: row => row.debit,
      sortable: true,
    },
    {
      name: "Credit",
      selector: row => row.credit,
      sortable: true,
    },
    {
      name: "Posted By",
      selector: row => row.user,
      sortable: true,
      cell: (row) => {
        return (
          <React.Fragment>
            <img
              src={row.user.avatar}
              className="avatar"
              alt={row.user.name || row.user.id}
            />
          </React.Fragment>
        );
      },
    },
    {
      name: "Action",
      selector: row => row.id,
      sortable: true,
      cell: (row, i) => {
        return (
          <React.Fragment key={i}>
            <button
              className="table-action btn btn-square btn-pure hover-success"
              onClick={() => {
                SetselectedId(row.id);
                SetselectedType(row.type);
                SetshowQuick(true);
              }}
            >
              <span className="material-icons-outlined">visibility</span>
            </button>
            <button className="table-action btn btn-square btn-pure hover-warning">
              <span className="material-icons-outlined">edit_note</span>
            </button>
            <button
              className="table-action btn btn-square btn-pure hover-danger"
              onClick={() => {
                SetselectedId(row.id);
                SettriggerModal(true);
              }}
            >
              <span className="material-icons-outlined">delete</span>
            </button>
          </React.Fragment>
        );
      },
    },
    ];

  const customStyles = {
    headCells: {
      style: {
        padding: "12px 16px",
        fontWeight: "bold",
        fontSize: "14px",
        backgroundColor: "#f8f9fa",
      },
    },
    cells: {
      style: {
        padding: "10px 16px",
        fontSize: "13px",
      },
    },
  };

  const filteredData = tableData.filter(
    item =>
      Object.values(item).some(val =>
        String(val).toLowerCase().includes(filterText.toLowerCase())
      )
  );

  return (
    <React.Fragment>
      <div className="card card-shadowed animated fadeInDownBig ng-scope">
        <div className="card-title row">
          <h2 className="col-4">Day Book</h2>
          <div className="form-group col-3">
            <label>Day</label>
            <DatePicker
              dateFormat="yyyy-MM-dd"
              className="form-control"
              maxDate={new Date()}
              closeOnScroll={true}
              selected={startDate}
              value={startDate}
              onChange={(e) => {
                SetstartDate(e);
              }}
              withPortal
              placeholderText="Select Day"
            />
          </div>
        </div>
      </div>
      <QuickView
        trigger={showQucik}
        type={selectedType}
        id={selectedId}
        hideTrigger={SetshowQuick}
      />
      <DeletePop
        trigger={triggerModal}
        delUrl={`/Module/Vouchers/Main/Delete?id=${selectedId}`}
        hideTrigger={SettriggerModal}
        fallAction={fetchDayBook}
      />
      <FileViewer
        trigger={viewerTrigger}
        doc={selectedFile}
        hideTrigger={SetviewerTrigger}
      />
      <div className="card">
        <h4 className="card-title">
          Results for <strong>{format(startDate, "yyyy-MM-dd")}</strong>
        </h4>
        <div className="card-body">
          <div className="row">
            <div className="col-lg-12">
              <div className="mb-3">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search..."
                  onChange={e => setFilterText(e.target.value)}
                />
              </div>
              <DataTable
                className="table"
                keyField="id"
                columns={columns}
                data={filteredData}
                pagination
                paginationRowsPerPageOptions={[10, 20, 30, 50, 100]}
                paginationPerPage={10}
                customStyles={customStyles}
                filter
                exportable
                loading={loading}
              />
            </div>
            <div className="col-md-6">
              <table className="table table-striped table-bordered">
                <tbody>
                  <tr>
                    <td style={{ textAlign: "right" }} width={200}>
                      Total Debit Amount :
                    </td>
                    <td>{(totalData.debit || 0).toFixed(2)}</td>
                  </tr>
                  <tr>
                    <td style={{ textAlign: "right" }} width={200}>
                      Total Credit Amount :
                    </td>
                    <td>{(totalData.credit || 0).toFixed(2)}</td>
                  </tr>
                  <tr>
                    <td style={{ textAlign: "right" }} width={200}>
                      Total Difference :
                    </td>
                    <td>
                      {(
                        (totalData.debit || 0) - (totalData.credit || 0)
                      ).toFixed(2)}
                    </td>
                  </tr>
                  {/* <tr>
                      <td style={{ textAlign: "right" }} width={200}>
                        Total Cash Amount :
                      </td>
                      <td>{totalData.cash || 0}</td>
                    </tr>
                    <tr>
                      <td style={{ textAlign: "right" }} width={200}>
                        Total Cheque Amount :
                      </td>
                      <td>{totalData.bank || 0}</td>
                    </tr> */}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}
